/* eslint no-loop-func:0 */

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
	withStyles,
	FormControl,
	InputLabel,
	OutlinedInput,
	FormHelperText,
	Grid,
} from '@material-ui/core'
import { getPrediction } from '../../actions/luis'
import ActionType from '../../actions/ActionType'
import { contactsWithEmailsByIDSelector } from '../../selectors'
import { consumePrediction } from 'actions/predictions'
import language from 'utils/vast-languagepack'

const mapStateToProps = (state) => {
	const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
	const stats = task?.sms_stats || task?.email_stats
	const campaignStatus =
		state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
	const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
	const disabled = Boolean(
		(stats && automationTypeSelected !== 'stage') ||
			campaignStatus === 'L' ||
			campaignStatus === 'C',
	)

	return {
		value: state.tasks.addOrEdit.fields.smartTask.value,
		error: state.tasks.addOrEdit.fields.smartTask.error
			? state.tasks.addOrEdit.fields.smartTask.error
			: null,
		Entities: state.luis.prediction,
		groupsByID: state.contacts.groupsByID,
		contactsByID: contactsWithEmailsByIDSelector(state),
		groupLoadStatus: state.loadStatus.groups,
		predictions: state.predictions,
		taskID: state.tasks.addOrEdit.taskID,
		disabled,
	}
}

const mapDispatchToProps = (dispatch) => {
	const { Tasks } = ActionType
	const dispatchType = (type, payload) => (dispatch) =>
		dispatch({ type, payload })
	return bindActionCreators(
		{
			getPrediction,
			handleFieldChange: (name, value) =>
				dispatchType(Tasks.HANDLE_FIELD_CHANGE, { name, value }),
			focusParagraph: () => dispatchType(Tasks.SMART_TASK_FOCUS),
			blurTextField: () => dispatchType(Tasks.SMART_TASK_BLUR),
			consumePrediction,
		},
		dispatch,
	)
}

const styles = (theme) => ({
	textField: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
	},
	paragraph: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
		borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
		padding: '6px 0 7px',
		marginTop: '0px',
		marginBottom: '0px',
	},
	paragraphLabel: {
		marginLeft: theme.spacing.unit,
		fontSize: '11.5px',
	},
	notchedOutline: {
		borderRadius: 28,
		paddingLeft: '40px !important',
	},
})

class SmartNotes extends Component {
	componentDidMount() {
		this.forceUpdate()
		// if (this.props.predictions.sendEmail && this.props.taskID === 'new') {
		//   const query = this.props.predictions.sendEmail.query
		//   Promise.resolve(this.props.getPrediction(query))
		//     .then(() => this.props.consumePrediction('sendEmail'))
		//     .then(() => this.props.handleFieldChange('smartTask', query))
		// }
		// if (this.props.predictions.sendSms && this.props.taskID === 'new') {
		//   const query = this.props.predictions.sendSms.query
		//   Promise.resolve(this.props.getPrediction(query))
		//     .then(() => this.props.consumePrediction('sendSms'))
		//     .then(() => this.props.handleFieldChange('smartTask', query))
		// }
	}

	// componentDidUpdate(prevProps) {
	//   if (this.props.predictions.lastQuery !== prevProps.predictions.lastQuery) {
	//     if (this.props.predictions.sendEmail && this.props.taskID === 'new') {
	//       const query = this.props.predictions.sendEmail.query
	//       Promise.resolve(this.props.getPrediction(query))
	//         .then(() => this.props.consumePrediction('sendEmail'))
	//         .then(() => this.props.handleFieldChange('smartTask', query))
	//     }
	//     if (this.props.predictions.sendSms && this.props.taskID === 'new') {
	//       const query = this.props.predictions.sendSms.query
	//       Promise.resolve(this.props.getPrediction(query))
	//         .then(() => this.props.consumePrediction('sendSms'))
	//         .then(() => this.props.handleFieldChange('smartTask', query))
	//     }
	//   }
	// }

	// handleBlur = () => event => {
	//   const {
	//     blurTextField,
	//     getPrediction,
	//     contactsByID,
	//     groupsByID,
	//   } = this.props
	//   blurTextField()
	//   if (event.target.value.length > 0) {
	//     getPrediction(event.target.value, { contactsByID, groupsByID })
	//   }
	// }

	handleChange = (name) => (event) => {
		this.props.handleFieldChange(name, event.target.value)
	}

	// handleClick = () => {
	//   this.props.focusParagraph()
	// }

	render() {
		const { classes, value, error, disabled } = this.props

		return disabled ? (
			value ? (
				<>
					<FormHelperText>
						{language.task.add.labels.description}:
					</FormHelperText>
					<div>{value}</div>
				</>
			) : null
		) : (
			<Grid item xs={12}>
				<FormControl
					error={Boolean(error)}
					// onClick={this.handleClick}
					fullWidth
					variant="outlined"
					disabled={disabled}
				>
					<InputLabel
						ref={(ref) => {
							this.labelRef = ReactDOM.findDOMNode(ref)
						}}
						htmlFor={`formTextField${'Description'}`}
						shrink
						style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
					>
						{language.task.add.labels.description}
					</InputLabel>
					<OutlinedInput
						// onBlur={this.handleBlur()}
						id={`formTextField${'Description'}`}
						labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
						value={value}
						onChange={this.handleChange('smartTask')}
						placeholder={language.task.add.helperText.description}
						notched
						classes={{
							notchedOutline: classes.notchedOutline,
						}}
					/>
					<FormHelperText error={Boolean(error)}>{error}</FormHelperText>
				</FormControl>
			</Grid>
		)
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withStyles(styles)(SmartNotes))
